module.exports = __webpack_public_path__ + "img/setting.75cba08.svg";